// src/utils/personaUtils.js

// Internal IDs to URL-friendly slugs
export const PERSONA_SLUGS = {
  "mecenna": "restoration_artisan",
  "DIYMind": "diymind",
  "houseimprovemnts": "practical_craftsman",
  "wilkerdo": "fearless_builder",
  "woodshopdiaries": "everyday_woodsmith",
  "fixthisbuildthat": "builder_marksman",
  "everydayhomerepair": "house_doctor"
};

// Internal IDs to display names
export const PERSONA_DISPLAY_NAMES = {
  "mecenna": "Restoration Artisan",
  "DIYMind": "DIYMind",
  "houseimprovemnts": "Practical Craftsman",
  "wilkerdo": "Fearless Builder",
  "woodshopdiaries": "Everyday Woodsmith",
  "fixthisbuildthat": "Builder Marksman",
  "everydayhomerepair": "House Doctor"
};

// URL-friendly slugs to internal IDs (reverse mapping)
export const URL_TO_INTERNAL = {
  "restoration_artisan": "mecenna",
  "diymind": "DIYMind",
  "practical_craftsman": "houseimprovemnts",
  "fearless_builder": "wilkerdo",
  "everyday_woodsmith": "woodshopdiaries",
  "builder_marksman": "fixthisbuildthat",
  "house_doctor": "everydayhomerepair"
};

// Function to convert internal IDs to URL slugs
export function getUrlFriendlyBlogId(blogId) {
  if (!blogId) return blogId;
  
  const parts = blogId.split('_');
  const persona = parts[0];
  const urlPersona = PERSONA_SLUGS[persona] || persona;
  return `${urlPersona}_${parts.slice(1).join('_')}`;
}

// Function to convert URL slugs to internal IDs
export function getInternalBlogId(urlBlogId) {
  if (!urlBlogId) return urlBlogId;
  
  const parts = urlBlogId.split('_');
  const urlPersona = parts[0];
  const internalPersona = URL_TO_INTERNAL[urlPersona] || urlPersona;
  return `${internalPersona}_${parts.slice(1).join('_')}`;
}

// Function to convert internal persona ID to URL slug
export function getUrlFriendlyPersonaId(personaId) {
  return PERSONA_SLUGS[personaId] || personaId;
}

// Function to convert URL slug to internal persona ID
export function getInternalPersonaId(urlPersonaId) {
  return URL_TO_INTERNAL[urlPersonaId] || urlPersonaId;
}
